// MENZY full logo artwork (barber pole + crown + brush wordmark + taglines).
// size: "sm" | "md" | "lg"
export const Logo = ({ size = "md", className = "" }) => {
  const heights = {
    sm: "h-10",
    md: "h-12 sm:h-14",
    lg: "h-20 sm:h-24",
  };
  const h = heights[size] || heights.md;

  return (
    <img
      src="/assets/logo_full.png"
      alt="MENZY — Master Barber"
      data-testid="menzy-logo"
      className={`${h} w-auto object-contain select-none ${className}`}
      draggable={false}
    />
  );
};
